import { useState } from 'react';

export const useWithdrawModal = (
  reservedAmount: number | undefined,
  withdrawAmount: number | undefined,
  withdrawDate: string | undefined,
  commission: number | undefined,
  transferAmount: number | undefined,
) => {
  const [isOpen, showModal] = useState<boolean>(false);

  const modalProps = {
    isOpen,
    onRequestClose: () => showModal(false),
    reservedAmount,
    withdrawAmount,
    withdrawDate,
    commission,
    transferAmount,
  };

  return {
    modalProps,
    showModal,
  };
};
